import { Injectable } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UrlHelperService } from '../services/url-helper.service';
import { Session } from '../models/session.model';
import { AuthenticationService } from './authentication.serivce';

@Injectable()

export class GetOrganizationServicesService {

  public loaded = new Subject<boolean>();
  public isLoaded: boolean = false;
  organizationId: any;

  constructor(private http: HttpClient, private urlHelper: UrlHelperService, private auth: AuthenticationService) {
    this.organizationId = auth.getSession()?.organizationId;
  }

  getServicesByCurrentOrganization(): Observable<Response> {
    var url = this.urlHelper.getApiUrl() + "AuthUser/GetOrganizationServices/?organizationId=" + this.organizationId;
    return this.http.get<any>(url);
  }

}
